export default "__VITE_ASSET__DFq0Z6Qk__"